module.exports = __webpack_public_path__ + "img/fontawesome-webfont.912ec66d.acf3dcb7.svg";